<template>
  <header class="border-bottom p-3">
    <slot></slot>
  </header>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
header {
  height: 90px;
  h3 {
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    color: #49545C;
    line-height: 20.83px;
    word-break: break-all;
  }
}
</style>
